const contactInformation = {
  telephoneNumber: "+4640122700",
  email: "info@asmaskiner.se",
};

export const countryCodes = [
  {
    value: "SE",
    display: "Sverige (SE)",
  },
  {
    value: "NO",
    display: "Norge (NO)",
  },
  {
    value: "FI",
    display: "Finland (FI)",
  },
  {
    value: "DK",
    display: "Danmark (DK)",
  },
];

export { contactInformation };
